import { SocketMessagesApiModel } from '@api_patient/models/SocketMessagesApiModel';
import { AnalyticCategories } from '@application/analytic/analytic.service';
import { ChatCommunicatorProtocol, ParsedMessage } from '@feature/chat/chat_communicator_protocol';
import { SocketController } from '@visiba/axon';

export class AnonymousChatCommunicator implements ChatCommunicatorProtocol {
	public readonly analyticCategory = AnalyticCategories.AnonymousChat;

	public readonly topics = Object.freeze({
		getHistory: 'getmessages',
		retrieveMessages: 'messages',
		sendMessage: 'sendmessage',
		caseClosed: 'case_closed_v2',
		peerHasReadUntil: 'peer_has_read_until',
	});

	public readonly fileUploadDispositionUri = 'client/v2/userfiles';
	public readonly controllerInstance = null;

	constructor(public readonly connectionId: string) {
		// Empty
	}

	isValidSession(response: SocketMessagesApiModel): boolean {
		return this.connectionId === response.caseId.toString();
	}

	getHistory(controllerInstance: SocketController, callback: (data: unknown) => void): void {
		controllerInstance.invoke(
			this.topics.getHistory,
			{
				caseId: this.connectionId,
			},
			(response: SocketMessagesApiModel) => {
				callback(response);
			},
		);
	}

	parseIncomingMessages(response: SocketMessagesApiModel): ParsedMessage[] {
		return response.data;
	}

	parseOutgoingMessage(message: string | null, fileTickets: string[]): Record<string, unknown> {
		return {
			caseId: this.connectionId,
			text: message ?? '',
			fileTickets: fileTickets,
			textFormat: 'Plaintext',
		};
	}
}
